/** Mesma regra de src/utils/skuStorefront.js na API. */
const SKU_MAX_LENGTH = 50;
const SKU_STOREFRONT_RE = /^[A-Za-z0-9]+(?:-[A-Za-z0-9]+)*$/;

export function skuStorefrontError(sku) {
  const s = String(sku ?? "").trim();
  if (!s) return null;
  if (s.length > SKU_MAX_LENGTH) {
    return "SKU deve ter no máximo 50 caracteres.";
  }
  if (!SKU_STOREFRONT_RE.test(s)) {
    return "SKU inválido. Use letras, números e hífen simples, como 1854537, VO24228657 ou 12345-ABC. Espaço, barra, % e hífen duplo impedem a página do produto de abrir.";
  }
  return null;
}
